/*
 * UserCreate Messages
 *
 * This contains all the text for the UserCreate component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.UserCreate.title',
    defaultMessage: 'Create User',
  },
  saveButton: {
    id: 'app.containers.UserCreate.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.UserCreate.saveSuccess',
    defaultMessage: 'User has been successfully created.',
  },
  saveFailure: {
    id: 'app.containers.UserCreate.saveFailure',
    defaultMessage: 'Error. The user could not be created.',
  },
});
